/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ProcessSubTypesModel {

        public config: Wars.Domain.Model.ProcessSubTypeConfiguration;
        public systemSubTypeGroups: Wars.Domain.Model.SystemSubTypeGroup[];
        public processActions: Wars.Domain.Model.ProcessAction[];
        public processClaims: Wars.Domain.Model.ClaimDefinition[];

        private initialStateUniqueId: string;
        private editingProcessSubType: boolean;
        private currentProcessSubType: Wars.Domain.Model.ProcessSubType;

        constructor(
            private processConfigId: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private processSubTypeService: services.ProcessSubTypeService,
            private securityMatrixService: services.SecurityMatrixService,
            private systemLevelService: services.SystemLevelService,
            private processActionService: services.ProcessActionService,
            private claimDefinitionService: services.ClaimDefinitionService)
        {
            this.editingProcessSubType = false;
            this.currentProcessSubType = undefined;

            this.processConfigurationService.getPermitSubTypeInfo(processConfigId).then(
                (processConfiguration: Wars.Domain.Model.ProcessConfiguration) => {
                    this.config = processConfiguration.mySubTypeConfiguration;
                    var initialStatus = Enumerable.from(processConfiguration.myStatusCodeGroup.myStatuses).single(i => i.isInitialStatus);
                    var initialState = Enumerable.from(initialStatus.myStates).single(i => i.isInitialState);
                    this.initialStateUniqueId = initialState.uniqueIdentifier;
                });

            this.processActionService.getAllProcessActions(processConfigId).then(processActions => this.processActions = processActions);

            this.systemLevelService.getSystemLevelSubTypeGroups().then(
                (systemLevel) => {
                    this.systemSubTypeGroups = systemLevel.mySubTypeGroups;
                });

            this.claimDefinitionService.getAllProcessClaims(processConfigId).then(
                (processClaimDefinition) => {
                    this.processClaims = Enumerable.from(processClaimDefinition)
                        .where(i => i.specialClaimTagType == null)
                        .where(i => i.claimMapName == null)
                        .toArray();
                });
        }

        public addProcessSubType(): void {
            this.processSubTypeService.createNewSubType(this.config);
            this.save();
        }

        public save(): void {
            this.processConfigurationService.saveAllChanges();
        }

        public editSubType(subType: Wars.Domain.Model.ProcessSubType): void {
            this.editingProcessSubType = true;
            this.currentProcessSubType = subType;
        }

        public stopEditingSubType(): void {
            this.editingProcessSubType = false;
            this.currentProcessSubType = undefined;
        }

        public editSecurityMatrix(processSubType: Wars.Domain.Model.ProcessSubType): void {
            this.securityMatrixService.openSecurityMatrixModal(processSubType.myCreateSecurityMatrix, this.processConfigId, this.initialStateUniqueId);
        }
    }
}